
<span class="p-input-icon-left">
    <p-inputtext 
        type="text" 
        placeholder="Search"
        class="rounded-input"
        style="color: black;"
    ></p-inputtext>
    <p-button icon="pi pi-search"  :style="{'background-color' :  app_base_data.second_theme_color,}" rounded aria-label="Search" />
</span>